import type {Icon} from '@primer/octicons-react'
import {Label} from '@primer/react'

import styles from './CommandPill.module.css'

type CommandPillProps = React.ComponentProps<'button'> & {
  children: string
  icon: Icon
  isNew?: boolean
}

export const CommandPill = ({children, icon: Icon, isNew = false, ...buttonProps}: CommandPillProps) => {
  return (
    <button className={styles.button} {...buttonProps}>
      <Icon />
      <span className={styles.text}>{children}</span>

      {isNew && (
        <Label size="small" variant="accent">
          New
        </Label>
      )}
    </button>
  )
}
